<template>
  <div>
    <menubar :permission="permission"/>
    <div class="container">
      <div id="title" class="d-flex justify-content-start">
        <img src="/img/05_slash.svg" />
        <p class="h1">ポストエディット対訳ファイル一覧</p>
      </div>

      <div class="translated-files-head" :class=" $page.props.permission != 'オーナー' && $page.props.permission != 'マネージャー' ? 'translated-files-head__NonArchive' : '' ">
        <Link v-show="$page.props.permission == 'オーナー' || $page.props.permission == 'マネージャー'" :href="route('translated_bilingual_files.archivedIndex')" class="btn btn-archive-file">
          アーカイブ済み対訳ファイル
        </Link>
        <Link :href="route('file_translate.index')" class="btn btn-purple">
          ファイル翻訳
        </Link>
      </div>

      <table class="component_table bilingual-file-table" cellpadding="5">
        <thead>
          <tr>
            <th class="th--file-name">ファイル</th>
            <th class="th--status">状態</th>
            <th class="th--team-name">チーム</th>
            <th class="th--user-name">作成者</th>
            <th class="th--user-name">編集中の<br/>ユーザ</th>
            <th class="th--language-pair">言語ペア</th>
            <th class="th--aimodel-name">AIモデル</th>
            <th class="th--glossary-name">用語集</th>
            <th class="th--date">更新日</th>
            <th class="th--dl-icon">DL</th>
            <th class="th--checkbox"  v-if="$page.props.permission == 'オーナー' || $page.props.permission == 'マネージャー' || $page.props.permission == 'メンバー'">選択</th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="bilingualFile in translatedBilingualFiles"
            v-bind:class="
            [
              bilingualFile.status == 'PE' ? 'tr--pe' : 'tr--ai', 
              {'tr--readonly': bilingualFile.is_editing != 0}
            ]"
          >
            <td class="td--file-name">
              <div v-show="! bilingualFile.showNameInput" v-if="bilingualFile.status == 'PE'">
                <a role="button" class="link-class" @click.prevent="openEditPage(bilingualFile.id)">
                  {{ bilingualFile.name }}
                </a>
              </div>
              <div v-show="! bilingualFile.showNameInput" v-else>
                {{ bilingualFile.name }}
              </div>
              <input class="form-control" style="max-width: 100%; display: inline-block" v-show="bilingualFile.showNameInput" type="text" :value="bilingualFile.name" />
              <div class="mt-3" style="text-align: right;">
                <button v-show="bilingualFile.showNameInput" class="btn btn-red" style="font-size: 0.9rem; margin-left: 0.5rem" @click="changeFileName($event, bilingualFile.id)" >
                  更新
                </button>
                <button class="btn btn-purple" style="font-size: 0.9rem; margin-left: 0.5rem" @click="changeFileInputElement($event, bilingualFile.id)">
                  <span v-show="!bilingualFile.showNameInput">変更</span>
                  <span v-show="bilingualFile.showNameInput">戻す</span>
                </button>
              </div>
            </td>
            <!-- [TODO] ハードコーディング気味なので解消する -->
            <td>
              <div v-if="bilingualFile.status=='PE' && bilingualFile.is_editing == 0"> 編集可 </div> 
              <div v-else-if="bilingualFile.status=='PE' && bilingualFile.is_editing == 1"> 編集中 </div> 
              <div v-else-if="bilingualFile.status=='AI'"> 翻訳中 </div> 
              <div v-else-if="bilingualFile.status == 'FL'"> 翻訳失敗 </div>
            </td>
            <td>{{ bilingualFile.team.name }}</td>
            <td>{{ bilingualFile.user.name }}
              <div v-if="bilingualFile.user.deleted_at != null" >(削除済み)</div>
            </td>
            <td>
              <div v-if="bilingualFile.is_editing != 0" >
                <span v-if="bilingualFile.editing_user">{{ bilingualFile.editing_user.name }}</span>
                <span v-else>(削除済み)</span>
              </div>
              <div v-else></div>
            </td>


            <td>
              {{ bilingualFile.src_language_code }} → {{ bilingualFile.trg_language_code }}
            </td>
            <td class="td--aimodel-name">
              {{ bilingualFile.aimodel.name }}
            </td>
            <td class="td--glossary-name">
              <div v-if="bilingualFile.glossary !== null"> 
                {{ bilingualFile.glossary.name }} 
                <div v-if="bilingualFile.glossary.deleted_at != null" >(削除済み)</div>              
              </div>
              <div v-else> 選択なし </div>
            </td>

            <td>{{ showLocalDate(bilingualFile.updated_at, "-") }}</td>
            <td class="td--dl-icon">
              <a v-if="bilingualFile.status == 'PE'" :href="route('translated_bilingual_files.download', {id: bilingualFile.id,})">
                <img src="/img/12_download.svg" class="btn--download" />
              </a>
            </td>

            <td class="td--checkbox" v-if="$page.props.permission == 'オーナー' || $page.props.permission == 'マネージャー' || $page.props.permission == 'メンバー'">
              <input
                v-if="bilingualFile.is_editing == 0 || bilingualFile.status=='AI'" 
                type="checkbox" 
                :id="bilingualFile.id" 
                :value="bilingualFile.id" 
                v-model="selectedFiles"
              />
            </td>

          </tr>
        </tbody>
      </table>

      <div class="translated-files-foot" v-if="$page.props.permission == 'オーナー' || $page.props.permission == 'マネージャー' || $page.props.permission == 'メンバー'" >
        <button class="btn btn-purple" v-if="$page.props.permission == 'オーナー' || $page.props.permission == 'マネージャー'" @click="archiveFiles">アーカイブ</button>
        <button class="btn btn-red" @click="deleteFiles">削除</button>
      </div>

      <!-- <button @click="setLoginAuthority">
        ユーザー権限切り替え(デバッグ用)
      </button> -->
    </div>

    <footerComponent />
  </div>
</template>

<script>
import menubar from "@/Pages/Common/menu";
import { Link } from "@inertiajs/inertia-vue3";
import footerComponent from "@/Pages/Components/footer.vue";
import showLocalDate from "@/Pages/Components/showLocalDate.js";

export default {
  components: {
    menubar,
    footerComponent,
    Link,
  },
  props: {
    rootAimodels: Object,
    aimodels: Object,
    teams: Object,
    permission:String,
  },
  props: {
    translatedBilingualFiles: Object,
  },

  data() {
    return {
      selectedFiles: [],
      login_authority: false,
      archiveFileName: [],
      deleteFileName: [],
      post_edits: [
        {
          file: "aiueo",
          status: "AI",
          user: "富岡修",
          updated_date: "2022-02-13 21:30",
          language: "英→日",
          ai_model: "movie(sf)",
        },
        {
          file: "kakikukeko",
          status: "PE",
          user: "田中太郎",
          updated_date: "2022-12-23 11:23",
          language: "英→日",
          ai_model: "movie(sf)",
        },
      ],
    };
  },
  computed: {},
  methods: {
    openEditPage(fileId) {
      const url = this.route('post-edit.index', { id: fileId });
      const editPage = window.open(url, '_blank'); // 新しいウィンドウをスクリプトから開く
    },
    showLocalDate: function (date, separator) {
      return showLocalDate.showLocalDate(date, separator);
    },
    changeFileName: function( $event, id ){
      const newFileName = $event.srcElement.parentNode.parentNode.getElementsByTagName('input')[0].value;
      if ( newFileName === '' ){
        alert('対訳ファイル名を空白にすることはできません。');
        return;
      }

      const file = this.getFileById(id);
      file.name = newFileName;

      this.$inertia.put( this.route('translated_bilingual_files.update', file.id), file,{
        onSuccess:()=>{
          file.showNameInput = false;
          alert( '対訳ファイル名を変更しました。');
        },
        onError:(e)=>{
          alert(e.error_message);
        }
      });
    },
    changeFileInputElement( $event, id ){
      let file = this.getFileById(id);
      file.showNameInput = !file.showNameInput;

    },
    getFileById(id) {
      return this.translatedBilingualFiles.filter( (a)=>{return a.id == id;})[0];
    },
    visitPostEdit(id) {
      this.$inertia.visit(route('post-edit.index', {id: id,}));
    },
    setLoginAuthority() {
      this.login_authority = !this.login_authority;
    },
    openFile(fileName) {
      confirm(fileName + "を開きますか？");
    },
    downloadFile(fileName) {
      confirm(fileName + "をダウンロードしますか？");
    },
    archiveFiles() {
      if (this.selectedFiles.length == 0) {
        alert("選択列の一つ以上のチェックボックスにチェックしてください");
        return;
      }
      if (!confirm("選択したファイルをアーカイブします。よろしいですか？")) {
        return;
      }

      this.$inertia.patch(
        route(
          "translated_bilingual_files.archive",
          this.selectedFiles.join(",")
        ),
        {},
        {
          onSuccess: () => {
            alert("選択された対訳ファイルをアーカイブしました");
          },
          onError: (e) =>{
            alert(e.error_message);
          }
        }
      );
    },
    deleteFiles() {
      if (this.selectedFiles.length == 0) {
        alert("削除列の一つ以上のチェックボックスにチェックしてください");
        return;
      }
      if (!confirm("この操作はやり直せません")) {
        return;
      }
      this.$inertia.delete(
        route(
          "translated_bilingual_files.destroy",
          this.selectedFiles.join(",")
        ),
        {
          onSuccess: () => {
            alert("選択された対訳ファイルを削除しました");
            this.selectedFiles = [];
          },    
          onError: (e) =>{
            alert(e.error_message);
          },
          only: [],
        }
      );
    },
  },
  beforeMount() {
    this.translatedBilingualFiles.forEach((f)=>{
        f.showNameInput = false;
    });
  }
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 80vh;
}
//=[ページの見出し]==========================================================//
#title {
  margin: 3rem 0;
  img {
    width: 3rem;
    height: 3rem;
  }
  p {color: #333333;}
}
//==========================================================================//

//=[テーブル上部の要素]======================================================//
.translated-files-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0;
  .btn-archive-file {
    color: #763fd0;
    border-color: #763fd0;
    border-radius: 100vh;
  }
}

.translated-files-head__NonArchive{
  justify-content: flex-end;
}
//==========================================================================//

//=[テーブル本体]============================================================//
.bilingual-file-table {
  width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  text-align: center;
  thead {
    border-top: 2px;
    height: 3rem;
  }
  tbody {
    border-top: 0;
    tr.tr--ai > td {
      background: #e4d8f5;
    }
    td {
      padding: 10px;
    }
  }
}

// Table ヘッダの幅に関するスタイル
.th--file-name{width: 20%}
.th--aimodel-name, .th--glossary-name{width: auto;}
.th--team-name, .th--user-name, .th--date{width: 8rem;}
.th--language-pair{width: 6rem;}
.th--status{width: 5rem;}
.th--dl-icon, .th--checkbox{width: 4rem;}

.tr--readonly > td{ background: #e7e7eb; }

// Table セルに関するスタイル
.td--file-name, .td--aimodel-name, .td--glossary-name{
  text-align: left;
  padding: 0 0 0 1rem;
}

.td--dl-icon, .td--checkbox{
  text-align: center;
  vertical-align: middle;
}
.btn--download {width: 20px;}
//==========================================================================//

//=[テーブル下部の要素]======================================================//
.translated-files-foot {
  text-align: end;
  margin: 1rem 0;
  button {
    margin: 0 0 0 1rem;
  }
  .switchAuthority {
    text-align: start;
  }
  .buttonArchiveDelete {
    text-align: end;
  }
}
//==========================================================================//
</style>